import { render, staticRenderFns } from "./qZ.vue?vue&type=template&id=135fab97&scoped=true"
import script from "./qZ.vue?vue&type=script&lang=js"
export * from "./qZ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135fab97",
  null
  
)

export default component.exports